module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-square-dots-78d2ed87.svg";